import { z } from 'zod'

export const resetPasswordFormSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address')
    .transform(val => val.toLowerCase())
})

export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>

export const defaultResetPasswordFormValues: ResetPasswordFormValues = {
  email: ''
}
